import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyResourcesModule } from '../resources';
import { SkyTextExpandRepeaterComponent } from './text-expand-repeater.component';


export class SkyTextExpandRepeaterModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyTextExpandRepeaterComponent
  ],
  imports: [
    SkyResourcesModule,
    CommonModule
  ],
  exports: [
    SkyTextExpandRepeaterComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
